
<div class="settings-panel">
    <div class="panel-widget_inner pt-3 flex-column align-items-stretch">
        <div class="settings-panel__titre">Dashboard Calo</div>

        <br/>
        <div class="row">
            <div class="col-md-4 form-inline">
                <div style="max-width: 200px">
                    Filter :
                </div>
                <div class="c-radio  mr-3 ml-3">
                    <label>
                        <input (change)="typeView='equipe' ; loadDashboard()"
                               type="radio" [checked]="typeView == 'equipe'"/>
                        <span class="fa fa-check"></span><b>Par Equipe</b></label>
                </div>
                <div class="c-radio">
                    <label>
                        <input (change)="typeView='agent' ; loadDashboard()"
                               type="radio" [checked]="typeView == 'agent'"/>
                        <span class="fa fa-check"></span><b>Par Agent</b></label>
                </div>
            </div>
            <div class="col-md-4 col-sm-12" *ngIf="typeView == 'equipe'" >
                <span [canAcess]="['SUPER_ADMIN' ,  'MANAGER' , 'RESPONSABLE_PROD']" >
                    <ng-select [ngStyle]="{'display':'block', 'width': '100%'}"
                               bindLabel="name" bindValue="id"
                               placeholder="Toute vos équipes"
                               [(ngModel)]="selectedEquipesId" [ngModelOptions]="{standalone: true}"
                               (change)="loadDashboard()"
                               [items]="equipes" [multiple]="false"
                    ></ng-select>
                </span>
            </div>
            <div class="col-md-4 col-sm-12" *ngIf="typeView == 'agent'" >
                <span [canAcess]="['SUPER_ADMIN' ,  'MANAGER' , 'RESPONSABLE_PROD']" >
                    <app-search-users [placeholder]="'Sélectionner un agent'"
                                      [multiple]="false"
                                      [roles]="['AGENT']"
                                      (onSelectUser)="onUserSelection($event);"
                    ></app-search-users>
                </span>
            </div>
            <div class="col-md-4  col-sm-12 float-right" style="text-align: end; color: #FFF;">
                <ng-select [ngStyle]="{'display':'inline-block', 'width': '100%', 'text-align': 'initial'}"
                           [items]="[realCurrentYear, realCurrentYear-1, realCurrentYear-2, realCurrentYear-3]" [multiple]="false" [(ngModel)]="currentYear"
                           (change)="changeYear()" [ngModelOptions]="{standalone: true}">
                </ng-select>
            </div>
        </div>
        <br/>
        <span *ngIf="typeView == 'agent'" ><b>Agent :</b> {{selectedUser.firstName}} {{selectedUser.lastName}}</span>
        <br/>
        <br/>

        <div class="row">
            <div class="col-md-12">
                <div class="card card-default">
                    <div id="main" #main1 style="width:100%; height:332px;"></div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card card-default">
                    <app-pivot-table [id]="'div1'" [useUI]="false" [data]="dataArr" [config]="configChart[0]"
                                     (newConfig)="reportConfig($event)"></app-pivot-table>
                </div>
            </div>
        </div>

    </div>
</div>



<!--
<div class="row">
    <div class="col-md-12">
        <div class="card card-default" *ngIf="dataArr && configChart[0]">
            <app-pivot-table [id]="'div1'" [useUI]="false" [data]="dataArr" [config]="configChart[0]"
                             (newConfig)="reportConfig($event)"></app-pivot-table>
        </div>
    </div>
</div>
-->
